import * as types from "./actionTypes"
import { getStoredShipper } from "../../constants/utils"

export function fetchAllDashboardData(userPermissionData) {
    const { STORED_SHIPPER_NAME, STORED_RAILROAD_NAME } = getStoredShipper()
    return {
        type: types.FETCH_ALL_DASHBOARD_DATA,
        payload: {
            DisplayOptions: {
                ShowBadOrderDashboard: true,
                ShowCarOrderDashboard: true,
                ShowDwellTimeDashboard: true,
                ShowHoldMiscDashboard: true,
                ShowInventoryDashboard: true,
                ShowNetTonsDashboard: true,
                ShowNoEtaDashboard: true,
                ShowPipelineDashboard: true,
                ShowStorageDashboard: true,
            },
            ApiStandardParameters: {
                Road: STORED_RAILROAD_NAME,
                Shipper: STORED_SHIPPER_NAME,
            },
            accesRights: userPermissionData,
        },
    }
}

export function fetchDashboardSuccess(data, plans) {
    return {
        type: types.DASHBOARD_DATA_SUCCESS,
        payload: {
            data: data,
            plans: plans,
        },
    }
}

export function fetchDashboardFailure() {
    return {
        type: types.DASHBOARD_DATA_FAILURE,
    }
}

export function dashboardFilterSet(widget, data) {
    return {
        type: types.DASHBOARD_FILTER_SET,
        payload: {
            widget: widget,
            data: data,
        },
    }
}

export function dashboardFilterClear() {
    return {
        type: types.DASHBOARD_FILTER_CLEAR,
    }
}
